module.exports = __webpack_public_path__ + "img/camper_interiour_7.8a74d068.jpg";